<template>
  <div class="video-player">
    <video
      class="video-player__video"
      controls
      preload="metadata"
      ref="videoPlayer"
    >
      <source v-for="source in videoSources" :key="source.src" :src="source.src" :type="source.type" />
      The current browser does not support playing this video.
    </video>
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, ref, type Ref } from 'vue';
import emitter from '../../core/emitter';
import { E_MODAL_CUSTOM_EVENT } from '../../types/modals.enum';

interface IProps {
  videoSources: {
    src: string,
    type: string,
  }[],
};
defineProps<IProps>();

const videoPlayer: Ref<HTMLVideoElement | null> = ref(null);

emitter.on(E_MODAL_CUSTOM_EVENT.CLOSE_GUIDE, () => {
  if (videoPlayer.value) {
    videoPlayer.value.pause();
  }
});

onUnmounted(() => {
  if (videoPlayer.value) {
    videoPlayer.value.pause();
  }
});
</script>

<style scoped lang="scss">
.video-player {
  position: relative;
  max-width: 854px;

  &__video {
    width: 100%;
    height: 100%;
    max-width: 854px;
    max-height: 480px;
    transform: translate(0, 6px);
  }
}
</style>
